import styled from "styled-components";
export const Styles = styled.div`
  .panel-details-container {
    padding: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-start;
    gap: 30px;
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
  }
  .panel-img-container {
    width: 100%;
    height: 250px;
    overflow: hidden;
    border-radius: 10px;
    background: #00000050;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .contact-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    width: 100%;
    .title {
      line-height: 25px;
      font-size: 20px;
      font-weight: 600;
    }
    .data {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      gap: 30px;
    }
  }
  .panel-description {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    width: 100%;
    text-align: start;
  }
`;
